export class DocumentTableModel
{
    id:number;
    fileName:string ;
    description:string ;
    link: string;
    uploadDate: Date;
    uploadBy: string;
    customField: string;
}